import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../../services/auth/authService';
import { useTheme } from '../../context/ThemeContext';
import PlanZIcon from '../shared/PlanZIcon';

const Navbar = ({ user, userData }) => {
    const navigate = useNavigate();
    const { theme, toggleTheme, background, changeBackground } = useTheme();
    const [showBgMenu, setShowBgMenu] = React.useState(false);

    const backgroundGroups = {
        images: [
            { id: 'modern_logistic', label: 'Teknolojik Lojistik', color: '#1e293b', type: 'image' },
            { id: 'abstract_blue', label: 'Akıcı Mavi', color: '#172554', type: 'image' },
            { id: 'nature_minimal', label: 'Sakin Manzara', color: '#f0f9ff', type: 'image' },
        ],
        colors: [
            { id: 'solid_dark', label: 'Koyu Gece', color: '#0f172a', type: 'color' },
            { id: 'solid_navy', label: 'Lacivert', color: '#1e293b', type: 'color' },
            { id: 'gradient_royal', label: 'Asil Mavi', color: 'linear-gradient(135deg, #1e3a8a, #1e1b4b)', type: 'color' },
            { id: 'gradient_sunset', label: 'Granyit', color: 'linear-gradient(135deg, #1e293b, #334155)', type: 'color' },
            { id: 'gradient_forest', label: 'Orman', color: 'linear-gradient(135deg, #064e3b, #022c22)', type: 'color' },
            { id: 'soft_slate', label: 'Yumuşak Gri', color: '#f1f5f9', type: 'color' },
        ]
    };

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    return (
        <nav
            className="card-premium glow-theme"
            style={{
                position: 'sticky',
                top: 'var(--spacing-md)',
                zIndex: 100,
                margin: '0 var(--spacing-lg) var(--spacing-xl)',
                padding: '8px 24px',
                transition: 'all 0.3s ease',
                overflow: 'visible'
            }}
        >
            <div className="flex justify-between items-center h-full">
                <div className="flex items-center gap-md">
                    <Link to="/" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        fontSize: '1.2rem',
                        fontWeight: '800',
                        color: 'var(--text-primary)',
                        letterSpacing: '-0.5px',
                        textDecoration: 'none'
                    }}>
                        <span style={{ display: 'flex', alignItems: 'baseline', gap: '0px' }}>
                            <span style={{
                                fontSize: '1.55rem',
                                fontWeight: '800',
                                letterSpacing: '-0.5px',
                                color: 'var(--text-primary)',
                                fontFamily: 'Inter, sans-serif',
                                lineHeight: 1
                            }}>plan</span>
                            <span style={{
                                fontSize: '1.55rem',
                                fontWeight: '800',
                                letterSpacing: '-0.5px',
                                background: 'linear-gradient(135deg, #EF4444 0%, #F97316 50%, #F59E0B 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                fontFamily: 'Inter, sans-serif',
                                lineHeight: 1
                            }}>Z</span>
                        </span>
                    </Link>
                    <div style={{ width: 1, height: 20, background: 'var(--border-color)', margin: '0 4px' }}></div>
                    <span style={{
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        color: 'var(--text-secondary)',
                        background: 'var(--bg-hover)',
                        padding: '4px 10px',
                        borderRadius: '20px',
                        border: '1px solid var(--border-color)',
                        letterSpacing: '0.5px'
                    }}>
                        {userData?.tenantName || 'RTC'}
                        {userData?.transporterName && (
                            <>
                                <span style={{ margin: '0 8px', opacity: 0.4 }}>|</span>
                                <span>{userData.transporterName}</span>
                            </>
                        )}
                    </span>
                </div>

                <div className="flex items-center gap-lg">
                    {/* Background Switcher */}
                    <div style={{ position: 'relative' }}>
                        <button
                            onClick={() => setShowBgMenu(!showBgMenu)}
                            style={{
                                border: '1px solid var(--border-color)',
                                background: 'var(--bg-hover)',
                                color: 'var(--text-primary)',
                                padding: '6px 12px',
                                borderRadius: '12px',
                                fontSize: '0.8rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'all 0.2s'
                            }}
                            title="Arka Plan Değiştir"
                        >
                            <span>Arka Plan</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </button>

                        {showBgMenu && (
                            <div className="glass-panel" style={{
                                position: 'absolute',
                                top: '120%',
                                right: 0,
                                width: '220px',
                                padding: 'var(--spacing-sm)',
                                borderRadius: 'var(--radius-lg)',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 'var(--spacing-xs)',
                                zIndex: 1000
                            }}>
                                {Object.entries(backgroundGroups).map(([groupKey, groupItems]) => (
                                    <React.Fragment key={groupKey}>
                                        <div style={{
                                            fontSize: '0.65rem',
                                            padding: '8px 8px 4px',
                                            color: 'var(--text-light)',
                                            fontWeight: '800',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            opacity: 0.6
                                        }}>
                                            {groupKey === 'images' ? 'Görsel Arka Planlar' : 'Renk Paleti'}
                                        </div>
                                        {groupItems.map(bg => (
                                            <button
                                                key={bg.id}
                                                onClick={() => { changeBackground(bg.id); setShowBgMenu(false); }}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '1px solid transparent',
                                                    borderRadius: 'var(--radius-md)',
                                                    background: background === bg.id ? 'var(--bg-hover)' : 'transparent',
                                                    color: 'var(--text-primary)',
                                                    cursor: 'pointer',
                                                    textAlign: 'left',
                                                    transition: 'all 0.2s',
                                                    position: 'relative',
                                                    overflow: 'hidden'
                                                }}
                                                onMouseEnter={(e) => { if (background !== bg.id) e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
                                                onMouseLeave={(e) => { if (background !== bg.id) e.currentTarget.style.background = 'transparent'; }}
                                            >
                                                <div style={{
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: '6px',
                                                    background: bg.color,
                                                    border: '1px solid var(--border-color)',
                                                    flexShrink: 0,
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                }}></div>
                                                <span style={{ fontSize: '0.85rem', fontWeight: background === bg.id ? '700' : '500' }}>{bg.label}</span>
                                                {background === bg.id && (
                                                    <span style={{
                                                        marginLeft: 'auto',
                                                        color: 'var(--primary-color)',
                                                        fontWeight: 'bold',
                                                        fontSize: '1rem'
                                                    }}>✓</span>
                                                )}
                                            </button>
                                        ))}
                                        {groupKey === 'images' && <div style={{ height: '1px', background: 'var(--border-color)', margin: '4px 8px' }}></div>}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}

                        {/* Overlay to close menu */}
                        {showBgMenu && (
                            <div
                                style={{ position: 'fixed', inset: 0, zIndex: 999 }}
                                onClick={() => setShowBgMenu(false)}
                            />
                        )}
                    </div>

                    {/* Theme Switcher */}
                    <div className="flex items-center gap-xs bg-dark-card p-xs" style={{ background: 'var(--bg-secondary)', borderRadius: 'var(--radius-full)', border: '1px solid var(--border-color)' }}>
                        <button
                            onClick={() => toggleTheme('dark')}
                            style={{
                                width: '32px', height: '32px', borderRadius: '50%', border: 'none', cursor: 'pointer',
                                background: theme === 'dark' ? '#ffffff' : 'transparent',
                                color: theme === 'dark' ? '#000000' : 'var(--text-secondary)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                            }}
                            title="Koyu Tema"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
                        </button>
                        <button
                            onClick={() => toggleTheme('light')}
                            style={{
                                width: '32px', height: '32px', borderRadius: '50%', border: 'none', cursor: 'pointer',
                                background: theme === 'light' ? '#ffffff' : 'transparent',
                                color: theme === 'light' ? '#000000' : 'var(--text-secondary)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                            }}
                            title="Açık Tema"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
                        </button>
                        <button
                            onClick={() => toggleTheme('sepia')}
                            style={{
                                width: '32px', height: '32px', borderRadius: '50%', border: 'none', cursor: 'pointer',
                                background: theme === 'sepia' ? '#ffffff' : 'transparent',
                                color: theme === 'sepia' ? '#000000' : 'var(--text-secondary)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                            }}
                            title="Göz Koruma"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </button>
                        <button
                            onClick={() => toggleTheme('midnight')}
                            style={{
                                width: '32px', height: '32px', borderRadius: '50%', border: 'none', cursor: 'pointer',
                                background: theme === 'midnight' ? '#ffffff' : 'transparent',
                                color: theme === 'midnight' ? '#000000' : 'var(--text-secondary)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                            }}
                            title="Premium Gece"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                        </button>
                        <button
                            onClick={() => toggleTheme('pure')}
                            style={{
                                width: '32px', height: '32px', borderRadius: '50%', border: 'none', cursor: 'pointer',
                                background: theme === 'pure' ? 'var(--primary-color)' : 'transparent',
                                color: theme === 'pure' ? '#000000' : 'var(--text-secondary)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                            }}
                            title="Saf Siyah"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="3" width="7" height="7"></rect>
                                <rect x="14" y="3" width="7" height="7"></rect>
                                <rect x="14" y="14" width="7" height="7"></rect>
                                <rect x="3" y="14" width="7" height="7"></rect>
                            </svg>
                        </button>
                    </div>

                    <Link to="/profile" className="flex items-center gap-md" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                        <div className="flex flex-col items-end">
                            <span style={{ fontWeight: 'var(--font-semibold)', fontSize: 'var(--text-sm)', color: 'var(--text-primary)' }}>{userData?.fullName}</span>
                            <span style={{
                                fontSize: '0.65rem',
                                fontWeight: 'var(--font-bold)',
                                color: 'var(--text-light)',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                opacity: 0.8
                            }}>
                                {userData?.transporterName || userData?.role}
                            </span>
                        </div>
                        <div style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
                            border: '1px solid var(--border-color)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontWeight: 'var(--font-bold)',
                            boxShadow: 'var(--shadow-md)'
                        }}>
                            {userData?.fullName?.charAt(0)}
                        </div>
                    </Link>
                    <button
                        className="btn btn-sm"
                        onClick={handleLogout}
                        style={{
                            border: '1px solid var(--border-color)',
                            background: 'var(--bg-hover)',
                            color: 'var(--text-primary)'
                        }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 4 }}>
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="11" y2="12"></line>
                        </svg>
                        Çıkış
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
